import React from 'react';
import {Link} from 'react-router-dom';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {
    faHeartPulse, faDiagramProject, faCoins, faComments, faStethoscope, faHandshakeAngle,
} from '@fortawesome/free-solid-svg-icons';
import DashboardShell from './DashboardShell';

const DASHBOARDS = [
    {to: '/admin/dashboards/ops-health', icon: faHeartPulse, label: 'Platform Operations & Health', sub: 'System status and migrations', color: '#0ab39c'},
    {to: '/admin/dashboards/collaboration-pipeline', icon: faDiagramProject, label: 'Collaboration Pipeline', sub: 'Requests to active collaborations', color: '#405189'},
    {to: '/admin/dashboards/revenue-billing', icon: faCoins, label: 'Revenue & Billing', sub: 'Payments and gateway performance', color: '#f7b84b'},
    {to: '/admin/dashboards/communications', icon: faComments, label: 'Communications Engagement', sub: 'Message and call volume', color: '#8b5cf6'},
    {to: '/admin/dashboards/clinical-quality', icon: faStethoscope, label: 'Clinical Quality & Outcomes', sub: 'Consultation and diagnostic activity', color: '#f06548'},
    {to: '/admin/dashboards/partner-performance', icon: faHandshakeAngle, label: 'Partner & Facility Performance', sub: 'Active partners and services', color: '#299cdb'},
];

/** Single entry point linking all six dashboards
 * (execution_strategy_activity_tracker.md, Phase 4) - reachable from each
 * institution dashboard variant's Quick Access grid. */
const DashboardsHub: React.FC = () => (
    <DashboardShell title="Analytics Dashboards" subtitle="Platform-wide reporting and operations">
        <div className="row g-3">
            {DASHBOARDS.map((d) => (
                <div key={d.to} className="col-md-6 col-lg-4">
                    <Link to={d.to} className="uz-quick-card text-start d-flex align-items-center gap-3" style={{padding: '1.25rem'}}>
                        <div className="uz-quick-icon" style={{background: `${d.color}1f`, color: d.color}}>
                            <FontAwesomeIcon icon={d.icon}/>
                        </div>
                        <div>
                            <h6 className="mb-1">{d.label}</h6>
                            <small className="text-muted">{d.sub}</small>
                        </div>
                    </Link>
                </div>
            ))}
        </div>
    </DashboardShell>
);

export default DashboardsHub;
